import script from "./departmentTree.vue?vue&type=script&setup=true&lang=js"
export * from "./departmentTree.vue?vue&type=script&setup=true&lang=js"

import "./departmentTree.vue?vue&type=style&index=0&id=36cd3484&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36cd3484"]])

export default __exports__